import React, { useState } from "react";
import EventSection from "./EventSection";
import { Link } from "react-router-dom";
import { ListGroup, ListGroupItem, Collapse } from "reactstrap";
import Scooter from "./Scooter";
import accounting from "accounting";
import Icon from "@fortawesome/react-fontawesome";

export const Queue = (queue_position, orientation) => {
  if (queue_position > 0) {
    if (orientation === "horizontal") {
      return (
        <div className="row text-left align-content-center justify-content-center">
          <div className="pl-4">
            <h5 className="p-2 m-0">
              <b>Hi, thank </b>
              <br />
              you for waiting
            </h5>
            <h6 className="px-2 m-0">
              {" "}
              your position
              <br /> in queue:
            </h6>
          </div>
          <div className="queue-display-horizontal">{queue_position}</div>
        </div>
      );
    } else {
      return (
        <div className="col-12 text-center align-content-center">
          <div>
            <h3 className="p-2 m-0">
              <b>Hi, thank you for waiting</b>
            </h3>
            <h5 className="p-2 m-0"> your position in queue:</h5>
            <br />
          </div>
          <div className="row justify-content-center">
            <div className="queue-display">{queue_position}</div>
          </div>
        </div>
      );
    }
  }
  return null;
};
const contractInfo = currentContract => (
  <div className="row">
    <div className="col-md-12">
      <label>
        Labor Rate:{" "}
        <b>{accounting.formatMoney(currentContract.labor_rate)}/Hour</b>
      </label>
      &nbsp;
      <label>
        Warranty: <b>{currentContract.warranty}</b>
      </label>
    </div>
  </div>
);

const TrackSection = ({ currentContract }) => {
  const [toggledOn, setToggledOn] = useState(false);
  const toggle = () => {
    setToggledOn(!toggledOn);
  };
  return (
    <>
      <div className="row">
        <div className="col-md-12 mb-3 contract-header">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6 mb-2 contract-title">
              Contract <b className="pl-2">#{currentContract.tracking_number}</b>
            </div>
          </div>

          <div className="row">
            <ListGroup className="scooter-info" flush>
              <ListGroupItem className="scooter">
                <div className=" mb-2" onClick={toggle}>
                  <label>
                    View contract info{" "}
                    <Icon icon={toggledOn ? "chevron-up" : "chevron-down"} />
                  </label>
                  <Collapse isOpen={toggledOn}>
                    <Scooter
                      scooter={currentContract.scooter}
                      keyTag={currentContract.key_tag}
                    />
                    <div className="mb-2 selectable">{contractInfo(currentContract)}</div>
                  </Collapse>
                </div>
              </ListGroupItem>
            </ListGroup>
          </div>
        </div>
        <div className="row justify-content-center">
          {Queue(currentContract.queue_position)}
          <div className="col-12 px-5">
            <div className="col-12 text-left px-0  pb-3">
              <h3>Track your order</h3>
            </div>
            <EventSection events={currentContract.events} />
          </div>
          <div className="row sticky-bottom w-100 px-3">
            <Link
              className="col-12  btn btn-track btn-sticky"
              to={`/contracts`}
            >
              <div className="">
                {/* /${currentContract.tracking_number} */}
                View less
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrackSection;
